define('common/views/404',['require','exports','module','base/view','ldsh!../templates/404'],function(require, exports, module) {
  "use strict";

  var View = require("base/view");

  module.exports = View.extend({
    template: require("ldsh!../templates/404"),
    onRender: function() {
      this.$el.i18n();
    }
  });
});

